export default __webpack_public_path__ + "static/media/G0890-Management_of_PPH_flowchart.1702899480000.908841e1.jpg";